<template>
  <div class="sostituto">

    <div class="WEB-actions col-24 no-padding">
      <el-button class="WEB-button WEB-button-primary right" @click="add()">
        {{ $t('sostituto.nuovoSostituto').toUpperCase() }}
      </el-button>
    </div>

    <div class="col-24 no-padding">
      <el-table :data="sostituti" width="100%" class="custom-table table-sostituto"
        :height="100 % - 56 - 50 - 50 - 60 - 5">
        <el-table-column :label="($t('sostituto.sostituto'))" min-width="150">

          <template slot-scope="scope">
            <div class="name-wrapper">
              {{ scope.row.cognome + ' ' + scope.row.nome }}
            </div>
          </template>

        </el-table-column>
        <el-table-column header-align="center" align="center" :label="($t('sostituto.nazioneSost'))" min-width="150">

          <template slot-scope="scope">
            <div class="name-wrapper">
              {{ ($t('sostituto.country.' + scope.row.nazione)) }}
            </div>
          </template>

        </el-table-column>
        <el-table-column header-align="center" align="center" :label="($t('sostituto.dataDa'))" min-width="120">

          <template slot-scope="scope">
            <div class="name-wrapper">
              {{ scope.row.dataDal | formatDate }}
            </div>
          </template>

        </el-table-column>
        <el-table-column header-align="center" align="center" :label="($t('sostituto.dataA'))" min-width="120">

          <template slot-scope="scope">
            <div class="name-wrapper">
              {{ scope.row.dataAl | formatDate }}
            </div>
          </template>

        </el-table-column>
        <el-table-column align="center" header-align="center" width="60">

          <template slot-scope="scope">
            <div class="elimina-wrapper">
              <icon v-if="(scope.row.seGest === 'S')" class="pointer" name="riv-delete2" scale="1"></icon>
            </div>
          </template>

        </el-table-column>
        <el-table-column width="50">

          <template slot-scope="scope">
            <div class="data-wrapper">
              <icon name="riv-delete2" scale="1.2" class="pointer" @click.native.stop="del(scope.row)"></icon>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>


    <!-- Dialog di creazione di una nuova richiesta di ferie -->
    <el-dialog :title="($t('sostituto.titolo').toUpperCase())" :visible.sync="showModal" class="custom-dialog"
      :append-to-body="true" custom-class="offset-7 col-10">
      <el-form class="">


        <div class="elemento row row-custom">
          <div class="my-label col-6 no-padding">
            {{ $t('sostituto.country.label') }}
          </div>
          <div class="my-value col-18 no-padding">
            <el-select v-model="form.country" @change="loadGruppi">
              <el-option v-for="item in countries" :key="item.codice" :label="($t('sostituto.country.' + item.codice))"
                :value="item.codice">
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="elemento row row-custom">
          <div class="my-label col-6 no-padding">
            {{ $t('sostituto.gruppo') }}
          </div>
          <div class="my-value col-18 no-padding">
            <el-select v-model="form.gruppo" @change="loadDitte" filterable>
              <el-option v-for="item in tbl_gruppi" :key="item.id" :label="item.desc" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="elemento row row-custom">
          <div class="my-label col-6 no-padding">
            {{ $t('sostituto.ditta') }}
          </div>
          <div class="my-value col-18 no-padding">
            <el-select v-model="form.ditta" @change="changeDitta">
              <el-option v-for="item in tbl_ditte" :key="item.id" :label="item.desc" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="elemento row row-custom">
          <div class="my-label col-6 no-padding">
            {{ $t('sostituto.dipendenti') }}
          </div>
          <div class="my-value col-18 no-padding">
            <el-select v-model="form.ccSostituto" placeholder="" clearable filterable remote reserve-keyword
              :remote-method="((query) => searchEmployee(query))" :loading="loading">
              <el-option v-for="item in tbl_Employee" :key="item.ccDipendente" :label="item.cognome + ' ' + item.nome"
                :value="item.ccDipendente">
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="elemento row row-custom">
          <div class="my-label col-6 no-padding">
            {{ $t('sostituto.periodo') }}
          </div>

          <div class="my-value col-16 no-padding">
            <el-date-picker class="dt-picker" v-model="form.periodo" type="daterange"
              :range-separator="$t('placeholder.rangeSeparator')" :start-placeholder="$t('placeholder.startDate')"
              :end-placeholder="$t('placeholder.endDate')" format="dd/MM/yyyy" value-format="yyyyMMdd" :picker-options="{
                firstDayOfWeek: 1
              }">
            </el-date-picker>
          </div>
        </div>

        <div class="elemento row row-custom">
          <div class="my-label col-6 no-padding">
            {{ $t('sostituto.nazioneSost') }}
          </div>
          <div class="my-value col-18 no-padding">
            <el-select v-model="form.nazioneSostituto">
              <el-option v-for="item in countries" :key="item.codice" :label="($t('sostituto.country.' + item.codice))"
                :value="item.codice">
              </el-option>
            </el-select>
          </div>
        </div>

      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button class="WEB-button WEB-button-alternative" @click="close">{{ $t('sostituto.btn.annulla')
          }}</el-button>
        <el-button class="WEB-button WEB-button-primary" @click="save">{{ $t('sostituto.btn.salva').toUpperCase()
          }}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: 'Sostituto',
  i18n: {
    messages: {
      it_IT: {
        sostituto: {
          titolo: 'Nomina Sostituto',
          nuovoSostituto: 'Nuovo Sostituto',
          sostituto: 'Sostituto',
          dataDa: 'Data Inizio',
          dataA: 'Data Fine',
          elimina: 'Elimina',
          gruppo: 'Gruppo',
          ditta: 'Ditta',
          dipendenti: 'Elenco Dipendenti',
          periodo: 'Periodo',
          nazioneSost: 'Nazione sostituto',
          separatore: 'to',
          btn: {
            annulla: 'Annulla',
            salva: 'Salva',
            add: 'Nuovo Sostituto',
            close: 'Chiudi'
          },
          country: {
            label: 'Nazioni',
            1: 'Italia',
            2: 'Francia',
            3: 'Spagna',
            4: 'Belgio',
            5: 'Germania'
          }
        }
      },
      fr_FR: {
        sostituto: {
          titolo: 'Nomination suppléant',
          nuovoSostituto: 'Nouveau suppléant',
          sostituto: 'Suppléant',
          dataDa: 'Du',
          dataA: 'Au',
          elimina: 'Elimine',
          gruppo: 'Groupes',
          ditta: 'Entreprises',
          dipendenti: 'Liste employés',
          periodo: 'period',
          nazioneSost: 'Pays suppléant',
          separatore: 'to',
          btn: {
            annulla: 'Annuler',
            salva: 'Sauvegarder',
            add: 'Nouveau suppléant',
            close: 'Près'
          },
          country: {
            label: 'Pays',
            1: 'Italie',
            2: 'France',
            3: 'Espagne',
            4: 'Belgique',
            5: 'Allemagne'
          }
        }
      },
      es_ES: {
        sostituto: {
          titolo: 'Sustituto',
          nuovoSostituto: 'Nuevo sustituto',
          sostituto: 'Sustituto',
          dataDa: 'Fecha inicio',
          dataA: 'Fecha fin',
          elimina: 'Eliminar',
          gruppo: 'Grupo',
          ditta: 'Empresa',
          dipendenti: 'Lista de empleados',
          periodo: 'Período',
          nazioneSost: 'Naciones sostituto',
          separatore: 'to',
          btn: {
            annulla: 'Anular',
            salva: 'Guardar',
            add: 'Añadir sustituto',
            close: 'Cierra'
          },
          country: {
            label: 'Naciones',
            1: 'Italia',
            2: 'Francia',
            3: 'España',
            4: 'Bélgica',
            5: 'Alemania'
          }
        }
      },
      de_DE: {
        sostituto: {
          titolo: 'Vertretung Festlegen',
          nuovoSostituto: 'Neuer Vertreter',
          sostituto: 'Vertretung',
          dataDa: 'Von',
          dataA: 'Bis',
          elimina: 'Löschen',
          gruppo: 'Gruppe',
          ditta: 'Unternehmen',
          dipendenti: 'Mitarbeiter',
          periodo: 'Zeitraum',
          nazioneSost: 'für Länder',
          separatore: 'bis',
          btn: {
            annulla: 'Abbrechen',
            salva: 'Speichern',
            add: 'Neuer Stellvertreter',
            close: 'Schließen'
          },
          country: {
            label: 'Land',
            1: 'Italien',
            2: 'Frankreich',
            3: 'Spanien',
            4: 'Belgien',
            5: 'Deutschland'
          }
        }
      },
      en_GB: {
        sostituto: {
          titolo: 'Appointment of the substitute',
          nuovoSostituto: 'New Substitute',
          sostituto: 'Substitute',
          dataDa: 'Start Date',
          dataA: 'End Date',
          elimina: 'Delete',
          gruppo: 'Group',
          ditta: 'Ditta',
          dipendenti: 'Employees',
          periodo: 'Period',
          nazioneSost: 'Nations Substitute',
          separatore: 'to',
          btn: {
            annulla: 'Cancel',
            salva: 'Save',
            add: 'New Substitute',
            close: 'Close'
          },
          country: {
            label: 'Nations',
            1: 'Italy',
            2: 'France',
            3: 'Spain',
            4: 'Belgium',
            5: 'Germany'
          }
        }
      }
    }
  },
  data() {
    return {
      sostituti: [],
      tbl_ditte: [],
      tbl_gruppi: [],
      tbl_Employee: [],
      form: {},
      showModal: false,
      loading: false,
      servizio: '',
      countries: [
        { "codice": "1" },
        { "codice": "2" },
        { "codice": "3" },
        { "codice": "4" },
        { "codice": "5" }],
    }
  },
  filters: {
    /* Formatta la data: GGMMAAAA --> GG/MM/AAAA */
    formatDate: function (date) {
      if (date !== '') {
        return date.substr(6, 2) + '/' + date.substr(4, 2) + '/' + date.substr(0, 4)
      } else {
        return ' '
      }
    }
  },
  mounted: function () {
  },
  activated: function () {
    this.initialize()
  },
  methods: {
    initialize: function () {
      let tree = this.$route.matched
      this.servizio = (tree[2] !== undefined) ? tree[2].meta.servizio : ''
      this.loadSostituti()
    },
    loadSostituti: function () {
      this.$http.get(this.servizio + '/' + this.$store.state.country + '/sostituti')
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, 'sostituti', response.body.data)
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    },
    add: function () {
      this.$set(this, 'form', {})
      this.$set(this.form, 'country', this.$store.state.country)
      this.$set(this.form, 'gruppo', '')
      this.$set(this.form, 'ditta', '')
      this.$set(this.form, 'ccSostituto', '')
      this.$set(this.form, 'periodo', [])
      this.$set(this.form, 'nazioneSostituto', this.$store.state.country)
      this.loadGruppi()
      this.showModal = true
    },
    save: function () {
      this.loading = true

      let obj = {
        'dataDal': this.form.periodo[0],
        'dataAl': this.form.periodo[1],
        'ccSostituto': this.form.ccSostituto,
        'op': '*ADD'
      }

      let country = this.form.nazioneSostituto !== "" ? this.form.nazioneSostituto : this.$store.state.country
      this.$http.post(this.servizio + '/' + country + '/sostituto', obj)
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
            this.loadSostituti()
            this.showModal = false
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    del: function (row) {
      this.loading = true

      let obj = {
        'dataDal': row.dataDal,
        'dataAl': row.dataAl,
        'ccSostituto': row.ccSostituto,
        'op': '*DEL'
      }

      this.$http.post(this.servizio + '/' + this.$store.state.country + '/sostituto', obj)
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
            this.loadSostituti()
            this.showModal = false
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    close: function () {
      this.showModal = false
    },
    loadGruppi: function () {
      this.$set(this.form, 'gruppo', '')
      this.$set(this.form, 'ditta', '')
      this.$set(this.form, 'ccSostituto', '')
      this.$set(this, 'tbl_gruppi', [])
      this.$set(this, 'tbl_ditte', [])
      this.$set(this, 'tbl_Employee', [])
      let country = this.form.country !== "" ? this.form.country : this.$store.state.country
      this.$http.get('datisoc/' + country + '/genragr')
        .then(response => {
          if (response.body.rc === 0) {
            this.tbl_gruppi = response.body.data
            //this.cerca()
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    },
    loadDitte: function (gruppo) {
      this.$set(this.form, 'ditta', '')
      this.$set(this.form, 'ccSostituto', '')
      this.$set(this, 'tbl_ditte', [])
      this.$set(this, 'tbl_Employee', [])
      let country = this.form.country !== "" ? this.form.country : this.$store.state.country
      this.$http.get('datisoc/' + country + '/gendit', {
        params: {
          codLang: sessionStorage.getItem('codLang'),
          numGru: '1',
          idGruppi: gruppo
        }
      }).then(response => {
        if (response.body.rc === 0) {
          this.tbl_ditte = response.body.data
        } else {
          this.$message({
            showClose: true,
            message: response.body.msg[0].msgTxt,
            type: 'error',
            duration: process.env.duration
          })
        }
        this.loading = false
      })
    },
    changeDitta: function () {
      this.loadEmployee('')
    },
    searchEmployee: function (query) {
      if (query !== '') {
        this.loadEmployee(query)
      } else {
        this.loadEmployee(query)
      }
    },
    loadEmployee: function (query) {
      this.loading = true
      let country = this.form.country !== "" ? this.form.country : this.$store.state.country
      this.$set(this, 'tbl_Employee', [])
      this.$set(this.form, 'ccSostituto', '')
      this.$http.get(this.servizio + '/' + country + '/sostpos', {
        params: {
          pag_action: 'BEGIN',
          pag_for: '50',
          pag_from: '1',
          radit: this.form.ditta,
          cognIni: query
        }
      }).then(response => {
        if (response.body.rc === 0) {
          this.tbl_Employee = response.body.data
        } else {
          this.$message({
            showClose: true,
            message: response.body.msg[0].msgTxt,
            type: 'error',
            duration: process.env.duration
          })
        }
        this.loading = false
      })
    }
  }
}
</script>


<style lang="less">
@import "../../assets/less/general.less";

.sostituto {

  .table-sostituto {
    margin-top: 10px;
    // WEB-header (56px) - WEB-title (50px) WEB-Action (50px) WEB-paginator (60px)
    height: calc(100vh - 56px - 50px - 50px - 60px - 5px);
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Sostituto/Sostituto.vue